// extracted by mini-css-extract-plugin
export default {"video-wrap":"VideoPlayer_video-wrap__+rUz9"};